<template>
  <div class="form">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="name">
      My Profile
      <span class="txt">
        {{ txt }}
      </span>
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input"
        name="first_name"
        placeholder="First Name"
        v-model="first_name"
        v-validate="'required|max:50'"
      />
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input"
        name="last_name"
        placeholder="Last Name"
        v-model="last_name"
        v-validate="'required|max:50'"
      />
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input toLowerCase"
        name="email"
        placeholder="E-mail"
        v-model="email"
        @keyup="changeFeild('email')"
        @change="changeFeild('email')"
        :class="{ invalid: errors.has('email') }"
        v-validate="'required|email'"
      />
    </div>
    <CodeNumber
      ref="emailCode"
      field="email"
      @nextStep="nextStep"
      @valError="valError"
      profile="true"
      :email="email"
      v-if="showCodeEmail"
    ></CodeNumber>
    <div
      class="txt"
      :class="{ textError: !$store.getters.userInfo.confirmed_email || emailValErr}"
    >
      {{ verifyEmailTxt }}
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input"
        placeholder="phone"
        v-model="phone"
        name="phone"
        v-validate="'required|min:16|phone_exist'"
        v-mask="'(###) ### - ####'"
        @keyup="changeFeild('phone')"
        @change="changeFeild('phone')"
      />
    </div>
    <div class="phone-validate-error" v-if="errors.has('phone')">
          {{errors.first("phone")}} 
    </div>
    <div v-else>
      <CodeNumber
        ref="phoneCode"
        v-if="showCodePhone"
        profile="true"
        @nextStep="nextStep"
        @valError="valError"
        field="phone"
      ></CodeNumber>
      <div
        class="txt"
        :class="{ textError: !$store.getters.userInfo.confirmed_phone }"
      >
        {{ verifyPhoneTxt }}
      </div>
    </div>
    <div class="consent-container">
      <div class="consent-header">Research Preferences</div>
      <div class="consent-item">
        <label for="consent-studies" class="consent-label">
          <div class="custom-checkbox-wrap">
            <input
              type="checkbox"
              id="consent-studies"
              class="checkbox"
              v-model="consent_future_studies"
            />
            <span class="custom-checkbox-mark"></span>
          </div>
          <div class="consent-text">
            <div class="consent-title">
              Yes, invite me to future research studies.
            </div>
            <div class="consent-desc">
              We’re working with scientists to understand how mold in homes connects to air quality and health. 
              If a study fits your home, we’ll email you to invite you. 
              Saying yes doesn’t sign you up for anything: 
              every study explains what’s involved and asks for your OK first

            </div>
          </div>
        </label>
      </div>

      <div class="consent-item">
        <label for="consent-partner" class="consent-label">
          <div class="custom-checkbox-wrap">
            <input
              type="checkbox"
              id="consent-partner"
              class="checkbox"
              v-model="consent_partner_research"
            />
            <span class="custom-checkbox-mark"></span>
          </div>
          <div class="consent-text">
            <div class="consent-title">
              Yes, my test results and answers can be used in research with
              partner scientists, with my name and contact details removed.
            </div>
          </div>
        </label>
      </div>
    </div>
    <button class="btn" @click="updateProfile">Save</button>
    <button class="btn change" @click="changeModal('password')">
      Change Password
    </button>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import CloseIcone from "../../../images/shared/cancel";
import CodeNumber from "../../registration/CodeNumber";

export default {
  name: "Personal",
  directives: { mask },
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      oldEmail: null,
      oldPhone: null,
      showCodeEmail: false,
      showCodePhone: false,
      verifyPhoneTxt: "Your phone number is not verified.",
      verifyEmailTxt: "Your email address is not verified.",
      txt: "",
      phoneCode: null,
      emailCode: null,
      emailValErr:false,
      consent_future_studies: false,
      consent_partner_research: false,
    };
  },
  components: {
    CodeNumber,
    CloseIcone
  },
  methods: {
    ...mapActions(["changeProfile", "saveNumber"]),
    setPhoneNumber(str) {
      return str.substring(1);
    },
    changeFeild (val){
      if (val === "phone") {
        this.showCodePhone = false;
      } 
      if (val === "email")  {
        this.showCodeEmail = false;
      }
    },
    valError(obj){
       var val_error = obj.error.data.messages.errors;
       var txt ="";
       for (let x in val_error) {
          if(val_error[x].field == "email" && val_error[x].validation == "unique"){
            this.emailValErr = true;
            this.verifyEmailTxt = val_error[x].message;
            return;
          } else if(val_error[x].field == "confirmation_email_code" && val_error[x].validation == "required"){
             this.emailValErr = true;
             this.verifyEmailTxt = val_error[x].message;
          } 
        }
    },
    nextStep(obj) {
      if (obj.field === "phone") {
        this.showCodePhone = false;
        this.emailValErr = false;
        this.verifyPhoneTxt = "Your phone number has been successfully verified";
      } 
      if (obj.field === "email")  {
        this.showCodeEmail = false;
        this.emailValErr = false;
        this.verifyEmailTxt = "Your email has been successfully verified";
      }
      const data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email.toLocaleLowerCase(),
        phone: `1${this.phone.replace(/[\s-()+]/g, "")}`,
        phone_vcode:obj.phoneCode,
        email_vcode:obj.emailCode,
        type:'',
        consent_future_studies: this.consent_future_studies,
        consent_partner_research: this.consent_partner_research
      };
      this.verifyEmailTxt = "";
      this.changeProfile(data).then(res => {
        if(res.field == "email" && res.validation == "unique"){
          this.emailValErr = true;
          this.verifyEmailTxt = "This email is already registered.";
          return;
        }  else {
            this.emailValErr = false;
            this.verifyEmailTxt = "";
        }
        const contacts = {
          phone: res.data.data.user.phone,
          mail: res.data.data.user.email
        };
        this.saveNumber(contacts);
        this.txt = "Your Information was updated";
      });
      this.txt = "Your Information was updated.";
    },
    closeModal() {
      this.$emit("closeProfile", false);
    },
    updateProfile() {
        if(this.email && this.showCodeEmail) {
          this.$refs.emailCode.sendData();
        } else {
          this.dataChange('email');
        }
        if(this.phone && this.showCodePhone) {
          this.$refs.phoneCode.sendData();
        } else {
          this.dataChange('phone');
        }
    },
    dataChange(data_type){
         const data = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email.toLocaleLowerCase(),
          phone: `1${this.phone.replace(/[\s-()+]/g, "")}`,
          phone_vcode:this.phoneCode,
          email_vcode:this.emailCode,
          type:data_type,
          consent_future_studies: this.consent_future_studies,
          consent_partner_research: this.consent_partner_research,
        };
        this.changeProfile(data).then(res => {
          if(res.field == "email" && res.validation == "unique"){
           this.emailValErr = true;
           this.verifyEmailTxt = "This email is already registered.";
           return;
          } else {
            this.verifyEmailTxt = "";
          }
          const contacts = {
            phone: res.data.data.user.phone,
            mail: res.data.data.user.email
          };
          if((res.data.data.user.email !== this.email) || 
          (res.data.data.user.email  === this.email && res.data.data.user.confirmed_email !== true)){
            this.showCodeEmail = true;    
          } else {
            this.showCodeEmail = false;
          }
          if((res.data.data.user.phone !== `1${this.phone.replace(/[\s-()+]/g, "")}`) || 
          (res.data.data.user.phone === `1${this.phone.replace(/[\s-()+]/g, "")}` && res.data.data.user.confirmed_phone !== true)){
            this.showCodePhone = true;
          } else {
            this.showCodePhone = false;
          }
          this.saveNumber(contacts);
          this.txt = "Your Information was updated";
        });
    },
    changeModal(val) {
      this.$emit("changeModal", val);
    }
  },
  mounted() {
    this.first_name = this.$store.getters.currentUser.first_name;
    this.last_name = this.$store.getters.currentUser.last_name;
    this.email = this.$store.getters.currentUser.email;
    this.phone = this.$store.getters.currentUser.phone.substring(1);
    this.oldEmail = this.$store.getters.currentUser.email;
    this.oldPhone = this.$store.getters.currentUser.phone;
    if (this.$store.getters.currentUser.confirmed_phone) {
      this.verifyPhoneTxt = "";
    }
    if (this.$store.getters.currentUser.confirmed_email) {
      this.verifyEmailTxt = "";
    }
    const currentUser = this.$store.getters.currentUser;
    if (currentUser) {
      this.consent_future_studies = !!currentUser.consent_future_studies;
      this.consent_partner_research = !!currentUser.consent_partner_research;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.input.invalid {
  border: 1px solid $red;
}
.form {
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
  background-color: $white;
  max-width: 500px;
  width: 100%;
  position: relative;
}
.input-wrap {
  width: 100%;
  margin: 0 0 15px 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 36px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: $green;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.name {
  color: $blue;
  font-size: 27px;
  margin: 0 0 36px 0;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.close {
  position: absolute;
  right: 18px;
  top: 18px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  z-index: 20;
}
.txt {
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  color: orange;
  margin: 10px 0;
  text-align: center;
}
.phone-validate-error {
  color: $red;
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  margin: 10px 0;
  text-align: center;
}
.textError {
  color: $red;
}
.name .txt {
  font-family: TTNormsMedium, sans-serif;
  position: absolute;
  left: 0;
  bottom: -0px;
  color: green;
  font-size: 13px;
  width: 100%;
}
@media (max-width: 1024px) {
  .form {
    margin: auto;
  }
  .input-wrap {
    border: 1px solid #e4e4e4;
  }
  .name {
    display: flex;
    flex-direction: column;
  }
  .name .txt {
    position: static;
    padding: 10px 0 0 0;
    top: 0;
    left: 0;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 20px;
    max-width: 300px;
  }
  .name {
    font-size: 20px;
    margin: 0px 0 20px 0;
  }
  .input {
    font-size: 13px;
    padding: 10px 15px;
  }
  .btn {
    height: 40px;
    font-size: 15px;
  }
}
.consent-container {
  width: 100%;
  margin: 20px 0 10px 0;
  text-align: left;
}
.consent-header {
  font-size: 16px;
  font-family: TTNormsBold, sans-serif;
  color: $blue;
  margin-bottom: 12px;
  text-align: left;
}
.consent-item {
  margin-bottom: 15px;
}
.consent-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}
.custom-checkbox-wrap {
  position: relative;
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-right: 12px;
  margin-top: 2px;
  flex-shrink: 0;
}
.checkbox {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 1;
  margin: 0;
}
.custom-checkbox-mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $white;
  border: 2px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  transition: all 0.25s ease;
  pointer-events: none;
}
.consent-label:hover .custom-checkbox-mark {
  border-color: $green;
}
.checkbox:checked + .custom-checkbox-mark {
  background-color: $green;
  border-color: $green;
}
.custom-checkbox-mark:after {
  content: "";
  position: absolute;
  display: none;
  width: 5px;
  height: 9px;
  border: solid $white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  top: 2px;
  left: 5px;
}
.checkbox:checked + .custom-checkbox-mark:after {
  display: block;
}
.consent-text {
  flex: 1;
}
.consent-title {
  font-size: 14px;
  line-height: 19px;
  color: $gray;
  font-family: TTNormsBold, sans-serif;
}
.consent-desc {
  font-size: 12px;
  line-height: 16px;
  color: #666666;
  font-family: TTNormsRegular, sans-serif;
  margin-top: 3px;
}
</style>
